<template>
  <b-modal class="modal-lg" size="lg" :id="modal.id" :title="modal.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light">{{ t(modal.title, modal.title) }} - {{modal.invoiceItem ? modal.invoiceItem.reference : ''}}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="content-i" v-if="modal.invoiceItem">
        <div class="content-box px-0 py-0">
          <div class="element-wrapper mt-2 pb-0 pt-0">
            <ResponseInfo class="px-0 py-0" v-if="getResponseInfo.responseName === 'invoicingBatchesUpdateModalView'" />
          </div>
          <div class="element-wrapper pb-0">
            <div class="row">
              <b-form-group class="mt-1 col-lg-6 col-sm-6 padding-fix">
                <div class="col-lg-12 col-sm-12 px-0 py-0">
                  <h6 class="element-header">{{ t('titleDocumentsBy','titleDocumentsBy') }}</h6>
                </div>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelTotal', 'labelTotal') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.total_docs" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelDeleted', 'labelDeleted') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.deleted_docs" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByEmail', 'labelByEmail') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.total_emailed" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByFax', 'labelByFax') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.total_faxed" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByPost', 'labelByPost') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.total_posted" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelByDataTransfer', 'labelByDataTransfer') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1"  v-model.number="modal.invoiceItem.total_dataxferred" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByOnline', 'labelByOnline') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1"  v-model.number="modal.invoiceItem.online_docs" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelSum', 'labelSum') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" disabled min="0" step="1" v-model="sumDocs" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelDiff', 'labelDiff') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input disabled type="number" min="0" step="1" v-model="differenceDocs" class="form-control"/>
                </b-input-group>
              </b-form-group>
              <b-form-group class="mt-1 col-lg-6 col-sm-6 padding-fix">
                <div class="col-lg-12 col-sm-12 px-0 py-0">
                  <h6 class="element-header">{{ t('titlePagesBy','titlePagesBy') }}</h6>
                </div>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelTotal', 'labelTotal') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.total_pages" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelDeleted', 'labelDeleted') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.deleted_pages" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByEmail', 'labelByEmail') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.pages_emailed" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByFax', 'labelByFax') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.pages_faxed" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByPost', 'labelByPost') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.pages_posted" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelByDataTransfer', 'labelByDataTransfer') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.pages_dataxferred" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelByOnline', 'labelByOnline') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" step="1" v-model.number="modal.invoiceItem.online_pages" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelSum', 'labelSum') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" disabled min="0" step="1" v-model="sumPages" class="form-control"/>
                </b-input-group>
                <b-input-group class="mt-3">
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('labelDiff', 'labelDiff') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input disabled type="number" min="0" step="1" v-model="differencePages" class="form-control"/>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <div class="element-wrapper pt-1 pb-0">
            <div class="row">
              <b-form-group class="col-lg-12 col-sm-12 padding-fix">
                <div class="col-lg-12 col-sm-12 px-0 py-0">
                  <h6 class="element-header">{{ t('titleSetting','titleSetting') }}</h6>
                </div>
                <b-input-group>
                  <b-input-group-prepend class="col-lg-5 col-sm-6 px-0 py-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">*{{ t('labelStatus', 'labelStatus') }}</span></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-select v-model="modal.invoiceItem.status" :options="invoicingBatchStatuses" value-field="id" text-field="name">
                    <template #first>
                      <b-form-select-option :value="null" disabled> {{t('optionSelectBatchStatus', 'optionSelectBatchStatus')}} </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ close }">
      <button type="button" class="btn btn-secondary" @click="close()"> {{ t('cancelBtnText', 'cancelBtnText') }} </button>
      <button v-if="!loading && modal.invoiceItem" class="btn btn-primary" type="button" @click="updateItem" > {{ t('updateButtonText', 'updateButtonText') }} </button>
      <b-button v-else variant="primary" disabled>
        {{t('updateButtonText', 'updateButtonText')}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters} from "vuex"
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'ModalUpdateInvoicingBatchItem',
  components:{
    ResponseInfo,
  },
  props:['modal'],
  data () {
    return {
      loading: false,
    }
	},
	methods: {
    resetModal() {
      this.$emit('hide')
    },
    updateItem() {
      this.loading = true
      this.$emit('updateItem', this.onComplete)
    },
    onComplete() {
      this.loading = false
    },
    numberFormat(number) {
      let result = Number.parseInt(number)

      if (isNaN(result)) {
        return 0
      }

      return result
    },
	},
  computed: {
    ...mapGetters(['getResponseInfo']),
    invoicingBatchStatuses: {
      get() {
        return this.$store.getters.getInvoicingBatchStatuses
      }
    },
    sumDocs: {
      get() {
        return this.numberFormat(this.modal.invoiceItem.deleted_docs)
            + this.numberFormat(this.modal.invoiceItem.total_emailed)
            + this.numberFormat(this.modal.invoiceItem.total_faxed)
            + this.numberFormat(this.modal.invoiceItem.total_posted)
            + this.numberFormat(this.modal.invoiceItem.total_dataxferred)
            + this.numberFormat(this.modal.invoiceItem.online_docs)
      }
    },
    differenceDocs: {
      get() {
       return this.numberFormat(this.modal.invoiceItem.total_docs) - this.sumDocs
      }
    },
    sumPages: {
      get() {
        return this.numberFormat(this.modal.invoiceItem.deleted_pages)
            + this.numberFormat(this.modal.invoiceItem.pages_emailed)
            + this.numberFormat(this.modal.invoiceItem.pages_faxed)
            + this.numberFormat(this.modal.invoiceItem.pages_posted)
            + this.numberFormat(this.modal.invoiceItem.pages_dataxferred)
            + this.numberFormat(this.modal.invoiceItem.online_pages)
      }
    },
    differencePages: {
      get() {
        return this.numberFormat(this.modal.invoiceItem.total_pages) - this.sumPages
      }
    },
  },
}
</script>

<style scoped>

</style>